import { getRgObjectsOfType as f, RG_TYPE as r } from "@project-rouge/rg-core";
import { getPolygonArea as s } from "../../../geometry-utils/core/index14.js";
const d = (n, i) => {
  let o = 0;
  const t = f(n, r.Building);
  for (const l of t) {
    const g = l.data.levels.filter((e) => e.levelIndex === i);
    for (const e of g)
      e.isRoof || !e.geaPolygon || (o += s(e.geaPolygon));
  }
  return o;
};
export {
  d as getLevelGEA
};
//# sourceMappingURL=index19.js.map
